export const i18nSupportedLngs = ['en', 'de'];
export const i18nFallbackLng = 'de';
